import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-8xl font-bold text-navy-100">404</div>
        <h1 className="mt-4 text-2xl md:text-3xl font-bold text-navy-600">Page Not Found</h1>
        <p className="mt-2 text-gray-500">The page you are looking for does not exist or has been moved.</p>
        <button
          onClick={() => navigate('/')}
          className="mt-6 px-6 py-3 bg-gold-500 text-navy-700 font-semibold rounded-lg hover:bg-gold-400 transition-all cursor-pointer"
        >
          Go Back Home
        </button>
      </div>
    </div>
  );
}
